import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Wordmark";
import { PrivacyPolicy } from "@/components/PrivacyPolicy";
import { useMe } from "@/context/MeContext";

export default function PrivacyPolicyPage() {
  const { me } = useMe();
  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <header className="mx-auto flex h-20 max-w-3xl items-center justify-between px-5"><Wordmark /><Link to="/" className="text-sm underline">Back to Middle</Link></header>
      <main className="mx-auto max-w-3xl space-y-6 px-5 pb-32" data-testid="privacy-policy-page">
        <div><h1 className="text-4xl font-medium sm:text-5xl">Privacy Policy</h1>
          <p className="mt-2 text-sm text-slate-500">How Middle collects, uses and protects your personal information. The rules that apply depend on where you live. We've picked yours from {me?.jurisdiction ? "your account settings" : "your device's time zone"}, and you can change it below.</p></div>
        <PrivacyPolicy region={me?.jurisdiction} />
        <p className="text-xs text-slate-400">See also the <Link to="/terms" className="underline">Terms of Use</Link>.</p>
      </main>
    </div>
  );
}
